import React from 'react';
import PropTypes from 'prop-types';
import Select, { selectType } from 'Components/Select';
import Text from 'Components/Text';

export default class Row extends React.Component {
  _selectAction = action => {
    action.action();
  };

  _getStatusColor = () => {
    const { formula } = this.props;

    if (formula && formula.applicationStatus) {
      return `list-scene__status-label_${formula.applicationStatus.toString().toLowerCase()}`;
    }
    return '';
  };

  _getFormulaReadableStatus = () => {
    const { formula } = this.props;

    if (formula && formula.applicationStatus) {
      return formula.applicationStatus[0].toUpperCase() + formula.applicationStatus.slice(1).toLowerCase();
    }

    return '';
  };

  _getBackgroundColourStyle = () => {
    const { isOdd } = this.props;
    return isOdd ? '_background_color_pale_gray' : '_background_color_white';
  };

  _getTextColourStyle = key => {
    const { sortedBy } = this.props;

    if (sortedBy === key) return 'active';
    return '';
  };

  render() {
    const { formula, availableActionsList } = this.props;

    return (
      <div
        id={`formulaRowId${formula.baseOilNumber}`}
        className={`list-scene__table-row ${this._getBackgroundColourStyle()}`}
        onClick={availableActionsList[0].action}
      >
        <div className={`list-scene__status-bar_left ${this._getStatusColor()}`} />

        <div
          id='formulaOilNumberField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
          ${this._getTextColourStyle('baseOilNumber')} _width_pc_12`}
        >
          {formula.baseOilNumber || 'N/A'}
        </div>

        <div
          id='formulaBaseFormulaOilNumberField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
          ${this._getTextColourStyle('baseFormulaBaseOilNumber')} _width_pc_12`}
        >
          {formula.baseFormulaBaseOilNumber || 'N/A'}
        </div>

        <div
          id='formulaFormulatorNumberField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
          ${this._getTextColourStyle('formulatorNumber')} _width_pc_18`}
        >
          {formula.formulatorNumber}
        </div>

        <div
          id='formulaIsReadAcrossField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
          ${this._getTextColourStyle('isReadAcrossFormula')} _width_pc_12`}
        >
          {formula.isReadAcrossFormula ? 'Read-across' : 'Base'}
        </div>

        <div
          id='formulaEngineTypeField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
          ${this._getTextColourStyle('engineType')} _width_pc_10`}
        >
          {formula.engineType}
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'>
          <div
            id='formulaStatusField'
            className={`list-scene__status-label ${this._getStatusColor()} ${this._getTextColourStyle(
              'applicationStatus'
            )}`}
          >
            {this._getFormulaReadableStatus()}
          </div>
        </div>

        <div
          id='formulaFeeStatusField'
          className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'
        >
          <Text
            mainWrapperClassName='text__wrapper_primary _width_90 _margin_0'
            textClassName={`text__binary-status-text ${
              formula.isPaid ? 'true' : 'false'
            } _margin_0 ${this._getTextColourStyle('isPaid')}`}
            value={formula.isPaid ? 'Paid' : 'Unpaid'}
          />
        </div>

        <div
          id='formulaActionsField'
          className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'
        >
          <Select
            placeholder='Actions'
            selectionList={availableActionsList}
            itemNameIndicator='name'
            multiSelect
            handleSelect={this._selectAction}
            type={selectType.listActions}
          />
        </div>

        <div className={`list-scene__status-bar_right ${this._getStatusColor()}`} />
      </div>
    );
  }
}

Row.propTypes = {
  formula: PropTypes.object.isRequired,
  isOdd: PropTypes.bool.isRequired,
  zIndex: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/List/Row.jsx